module.exports = __webpack_public_path__ + "static/media/address-active.fc15c11f.svg";